export const calculateTimeToTypeText = (
  textToType: string,
  {
    maxMs = 2000,
    wordsPerSecond = 1.6,
  }: {
    maxMs?: number;
    wordsPerSecond?: number;
  } = {}
) => {
  const wordCount = textToType.split(' ').length;
  return Math.min((wordCount * 1000) / wordsPerSecond, maxMs);
};
